import { store } from '@/decorators/store';
import { Configuration } from '@/entities/Configuration';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'ConfigurationStore' })
export class ConfigurationStore extends AbstractEntityStore<Configuration> {
  protected entityIdKey = 'code';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
